import { render, staticRenderFns } from "./PackageDetail.vue?vue&type=template&id=798d20a3&scoped=true&"
import script from "./PackageDetail.vue?vue&type=script&lang=js&"
export * from "./PackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackageDetail.vue?vue&type=style&index=0&id=798d20a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d20a3",
  null
  
)

export default component.exports